"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFirestoreAuth = exports.RefBuilder = void 0;
// Save a copy of the built-in fetch for later
const _fetch = globalThis.fetch;
/**
 * Use this to confim that the provided `doc` exists and is "valid".  By
 * default we verify that the document is valid simply by checking that
 * it contains data (and is not empty).
 */
//export const verifyDoc = <S extends DocumentData>(
//  doc?: DocumentSnapshot<S>,
//  verify: (doc: DocumentSnapshot<S>) => boolean = (doc) => true,
//): doc is QueryDocumentSnapshot<S> =>
//  !!doc && !!doc.data() && doc.exists() && verify(doc);
/**
 * Enumerate the keys from the given object (which can also be an "enum").
 * This is convinient for looping over the keys of an object and maintining the
 * correct typings.  Usage:
 *
 *    for (const key in enumKeys(obj)) {
 *      const value = obj[key]; // This is now properly typed
 *      // Do something with value
 *    }
 */
const enumKeys = (obj) => {
    return Object.keys(obj || {}).filter((k) => Number.isNaN(+k));
};
const checkPath = (path) => {
    const parity = (path.replace(/^\/+|\/+$/g, "").split("/").length % 2 === 0 ? "even" : "odd");
    return parity;
};
/**
 * Generate a new function for building document and collection references
 * from the paths and data types defined in `Mapper`.
 */
const RefBuilder = (props) => {
    return (path, ...[params]) => {
        //
        // TODO: How to remove ts-ignore??
        //
        const truePath = enumKeys(params).reduce((path, key) => {
            // @ts-ignore
            return path.replace(`{${key}}`, params === null || params === void 0 ? void 0 : params[key]);
        }, path);
        const parity = checkPath(path);
        if (parity === "even") {
            // @ts-ignore
            return props.doc(props.getFirestore(), truePath);
        }
        // @ts-ignore
        return props.collection(props.getFirestore(), truePath);
    };
};
exports.RefBuilder = RefBuilder;
/**
 * Use this function to use a custom IAM auth token with Firestore.  The
 * provided function, getToken, should return Promise that resolved to the
 * custom IAM token (as a string) that should be used for all future requrests
 * to Firestore.
 *
 * Since the official Firebase SDK does not provide a way to supply an IAM
 * token we have to take a rather hacky approach to work around this.
 * Internally, this function swaps out the native `fetch` function with one
 * that detects calls to Firestore and swaps out the headers beore making the
 * actual request.
 */
const setFirestoreAuth = (getToken) => {
    const fetch = async (input, init) => {
        const url = input instanceof URL
            ? input.toString()
            : input instanceof Request
                ? input.url
                : input;
        if (typeof url === "string" && url.includes("firestore.googleapis.com")) {
            if (init === undefined) {
                init = { headers: {} };
            }
            const token = await getToken("https://www.googleapis.com/auth/cloud-platform");
            if (!token) {
                console.warn(`Custom Firestore token is empty.  This is probably bad...`);
            }
            console.debug("Overloading authorization headers...", { input });
            init.headers = { Authorization: `Bearer ${token || ""}` };
        }
        return _fetch(input, init);
    };
    globalThis.fetch = fetch;
};
exports.setFirestoreAuth = setFirestoreAuth;
//# sourceMappingURL=lite.js.map